import React, { useEffect, useState } from 'react';
import { DocumentScanning } from 'tradera-components/international-identification-modal/document-scanning';
import draftActions from 'tradera-state/views/syi/actions/draft-actions';
import { useDispatch } from 'react-redux';
import { useTranslator } from 'tradera-lang/translate';
import { closeModal } from 'tradera-state/ui/action-creators';
import { memberIdentificationClient } from 'tradera-utils/http';
import DialogModal from 'tradera-components/dialog/dialog-modal';
import ModalContainer from '../../../EbaySweden.TouchWeb/static/script/components/modals/modal-container';
import ModalHeader from '../../../EbaySweden.TouchWeb/static/script/components/modals/modal-header';
import ModalBody from '../../../EbaySweden.TouchWeb/static/script/components/modals/modal-body';
import { LocalLoader } from 'tradera-components/loader';
import {
    MitId,
    MitIdDesktop
} from 'tradera-components/international-identification-modal/mit-id';
import { MitIdLogo } from './mit-id-logo';
import styles from './international-identification-modal.module.scss';
import { isDesktop } from 'tradera-utils/breakpoints';

export const InternationalIdentificationModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslator();
    const [validIdentifications, setValidIdentifications] = useState(null);
    const [error, setError] = useState(null);
    const [selectedIdentification, setSelectedIdentification] = useState(null);

    useEffect(() => {
        memberIdentificationClient
            .query('getvalididentifications')
            .then(data => {
                setValidIdentifications(data.validIdentifications);
                return;
            })
            .catch(setError);
    }, [setValidIdentifications]);

    const selectedIdentificationGui = {
        DocumentScanning: () => (
            <DocumentScanning
                onVerifyComplete={() => {
                    dispatch(draftActions.publish(t));
                    dispatch(closeModal());
                }}
            />
        ),
        MitId: () =>
            isDesktop() ? (
                <MitIdDesktop
                    onVerifyComplete={() => {
                        dispatch(draftActions.publish(t));
                        dispatch(closeModal());
                    }}
                    onVerifyCancel={() => setSelectedIdentification(null)}
                />
            ) : (
                <MitId
                    onVerifyComplete={() => {
                        dispatch(draftActions.publish(t));
                        dispatch(closeModal());
                    }}
                    onVerifyCancel={() => setSelectedIdentification(null)}
                />
            )
    }[selectedIdentification];

    return (
        <DialogModal onDismiss={() => dispatch(closeModal())}>
            <ModalContainer
                onClose={() => dispatch(closeModal())}
                className={`${
                    !selectedIdentificationGui
                        ? styles.internationalIdentificationModalDynamicHeight
                        : ''
                }`}>
                <ModalHeader
                    className="border-bottom mt-0"
                    onClose={() => dispatch(closeModal())}>
                    {t('international_identification_heading')}
                </ModalHeader>
                <ModalBody className="justify-content-center position-relative pb-3">
                    {!selectedIdentificationGui && validIdentifications && (
                        <div className="d-flex flex-column px-7 py-4 text-center">
                            <div className="mb-4">
                                {t('international_identification_intro_text')}
                            </div>
                            {validIdentifications.some(x => x === 'MitId') && (
                                <>
                                    <button
                                        className={`w-100 btn btn-primary d-flex justify-content-center align-items-center ${styles.internationalIdentificationModalMitIdButton}`}
                                        onClick={() =>
                                            setSelectedIdentification('MitId')
                                        }>
                                        <MitIdLogo className="mr-2" />
                                        {t(
                                            'international_identification_mitid_button'
                                        )}
                                    </button>
                                    <div className="position-relative w-100 my-2">
                                        <span
                                            className={
                                                styles.internationalIdentificationModalDelineator
                                            }>
                                            {t(
                                                'international_identification_or'
                                            )}
                                        </span>
                                        <hr />
                                    </div>
                                </>
                            )}
                            <button
                                className="w-100 btn btn-outline-dark"
                                onClick={() =>
                                    setSelectedIdentification(
                                        'DocumentScanning'
                                    )
                                }>
                                {t(
                                    'international_identification_other_verifications'
                                )}
                            </button>
                        </div>
                    )}
                    {selectedIdentificationGui && selectedIdentificationGui()}
                    {!validIdentifications && !error && <LocalLoader />}
                    {error && (
                        <div className="px-7 py-4 text-center text-danger">
                            {t('international_identification_errorUnavailable')}
                        </div>
                    )}
                </ModalBody>
            </ModalContainer>
        </DialogModal>
    );
};

export const internationalIdentificationModalId =
    'internationalIdentificationModalId';
